import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FlexBox, CommitButtons } from "@/components/common";
import ModeButtons from "./ModeButtons.vue";
import UpdateButton from "./UpdateButton.vue";

/**
 * Renders options specific to the artifact graph.
 */
const __default__ = {
  name: "GraphBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), {
    "full-width": "",
    justify: "between",
    align: "center",
    y: "1"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), { align: "center" }, {
        default: _withCtx(() => [
          _createVNode(ModeButtons)
        ]),
        _: 1
      }),
      _createVNode(_unref(FlexBox), { align: "center" }, {
        default: _withCtx(() => [
          _createVNode(UpdateButton),
          _createVNode(_unref(CommitButtons))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})